class StatsService {
    static get = async () => {
        try {
            const response = await fetch('/api/statistics', {
                method: 'get',
            });

            return response.json();
        } catch (error) {
            console.log(error); // eslint-disable-line no-console
        }

        return {};
    };
}

export default StatsService;
